import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/layouts/Bullseye/bullseye';
export var Bullseye = function Bullseye(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'div' : _a$component,
      props = __rest(_a, ["children", "className", "component"]);

  var Component = component;
  return React.createElement(Component, Object.assign({
    className: css(styles.bullseye, className)
  }, props), children);
};